import Controller from "./promotion.controller";
import template from "./promotion.html";

const promotion = {
  template,
  controller: Controller,
};

export default promotion;



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.component.js